// Steuerbüro (/rechnung/steuerbuero); Inhalt in seiten/Steuerbuero.tsx (erst bei Bedarf geladen)
import { faul } from './faul';

export const SteuerbueroSeite = faul(() => import('./seiten/Steuerbuero'));
